module.exports = __webpack_public_path__ + "img/function_img4_fan.08ebdfdf.png";